export default {
    parts: [
        'visibilitySwitch',
        'visibilityText',
        'removeCollectionButton'
    ],
    baseStyle: {
        visibilitySwitch: {
            '& .chakra-switch__track': {bg: 'webTheme.iconDisabled'},
            '& .chakra-switch__track[data-checked]': {bg: 'webTheme.iconPrimary'},
            '& .chakra-switch__thumb': {bg: 'webTheme.iconOnColor'}
        },
        // Reserve two lines so the buttons below keep their position when the
        // longer (toggle OFF) copy wraps. 2 × the 20px bodySmRegular line height.
        visibilityText: {
            minHeight: '40px'
        },
        removeCollectionButton: {
            mt: '24px',
            mb: '16px',
            textTransform: 'none'
        }
    }
}
